import { render } from "./GroupSettings.vue?vue&type=template&id=7aa52e63&scoped=true"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"

import "./GroupSettings.vue?vue&type=style&index=0&id=7aa52e63&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa52e63"]])

export default __exports__